module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whoa, Baby!")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Swan Coach House. April 8, 2003. 11:20 A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Suddenly oblivious to the crowded, flower-filled tearoom around us, the four of us sat, stunned, our eyes fixed on Linda as she shoved the pregnancy test deeper into her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu exploded first. “What do you mean, it’s for you? How? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane glared at her. “You, of all people, know how.” The catty reference to SuSu’s numerous relationships was totally out of character, an indication of how shocked we all were.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From Linda’s dire expression, it was easy to see this was the menopausal woman’s nightmare, unplanned and unwelcome.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My own heart was pinging like a Ford Pinto running on bad gas. Linda couldn’t be pregnant. Brooks was only six months away from retirement. He’d been planning for years to take Linda around the world. A baby would ruin everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Noting our expressions, the women nearby instantly zeroed in on what was going on at our table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We all leaned into a protective huddle over the bud vase of fresh flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda, pregnant? Please, no. For so many reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We do not need to panic,” Diane whispered. She peered earnestly at Linda’s grim expression. “This kind of thing happens all the time, and it turns out to be menopause.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“Oh, hell, Diane,” SuSu argued, incapable of whispering discreetly. ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“She ought to know the difference.” Then she turned on Linda with, “How could you let this happen? Brooks is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("doctor")]), _vm._v(", for God’s sake. What about birth control?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda went scarlet. “It was only one time, and we were at…well, we didn’t have anything with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Away from home? Linda hadn’t been out of town for months. “What do you mean, you didn’t have anything with you?” I heard myself ask. “Where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("were")]), _vm._v(" you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda cocked a fierce look at me and bit out through pursed lips. “At the Fox frickin’ Theater, if you must know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brooks had been on the board there for years. My perverse mind wondered if he’d been “on the boards” there with Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Plump Brooks and Linda, stealing a risky quickie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("at the Fox Theater?")]), _vm._v(" “You are lyin’,” I challenged, knowing she wasn’t. Not about a thing like that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane chortled. “A grown human being can barely fit into those dinky little seats, much less—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where were y’all?” Teeny asked in amazement, her bright blue gaze sparkling with curiosity. “In the balcony?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flat-mouthed, Linda took refuge in, “I really couldn’t say.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rest of us promptly threw Tradition Five (Mind your own business) out the window. “Oh, don’t give me that,” I scolded. “This is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("us")]), _vm._v(". Spill it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing our eager expressions, Linda let out an exasperated sigh, then whispered tightly, “In the orchestra pit, if you must know. After a wrap party for the opera.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All three of us recoiled almost imperceptibly in shock. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not")]), _vm._v(" an image of shy, anything-not-to-be-noticed Brooks I would ever have imagined!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda defended, “We’d both had too much to drink, and we slipped back into the theater to watch the sky effects. One thing led to another, and…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of Brooks getting silly and enticing Linda into the orchestra pit was so funny I would have laughed, had the possible consequences not been so dire.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“It doesn’t matter where it happened. The only thing that matters is if it took or not.” SuSu brushed off the sidetrack with a wave of her ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("hand. “And if it did, what you’re going to do about it.” She peered into Linda’s face. “You don’t have to have it, you know.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since SuSu’s effort at a whisper was louder than my regular speaking voice, Linda and Diane glanced around to see if anyone had overheard, but there was no indication anyone had. The women at the next table seemed engrossed in their own conversations, and the elegant little old lady who lunched every day, almost always alone in her St. John suits at the same little double nearby, was safely out of earshot, staring politely into the middle distance as she always did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“SuSu!” I hissed, my pro-life convictions sorely tested. I remembered the days before she was widowed, when we’d marched side by side against Roe v. Wade.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny bristled up to the full extent of her tiny, devoutly Catholic self.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well,” SuSu justified, “she doesn’t have to go through with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny flicked a vicious swat with her rolled napkin at SuSu’s arm, eliciting a muffled yelp. “Bite your tongue for saying such a thing!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned to Linda. “God’s timing may not be our own, sweetie, but this could be a great blessing to you and Brooks. Think of Abraham and Sarah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda’s brows shot up. “Yeah, well, Sarah laughed when she found out. You won’t catch me doing that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny leaned even closer. “But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Teeny!” Diane clamped her hand across Teeny’s mouth. “You’re as bad as SuSu. Leave Linda alone. She’s an intelligent woman. She knows what her options are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I knew I should keep my mouth shut, but that’s never been my strong suit. “You don’t have to do anything drastic,” I murmured close to the gray hair curling softly over Linda’s ear beneath the turned-up brim of her red hat. “Plenty of childless couples would die for a baby from wonderful parents like you and Brooks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Georgia!” Diane turned on me. “Please. Leave the poor woman alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Y’all…” Miserable, Linda raised her palms in a staying gesture. “Stop fighting. I feel bad enough as it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How many times have you missed?” came out of my mouth, completely on its own.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three.” Since menopause was a major topic of conversation at these get-togethers, we all knew she was the last one of us still having periods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe Diane’s right,” I comforted. “Maybe it’s just menopause.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda shook her head in denial. “Not unless that comes with morning sickness.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh gosh, Linda.” Teeny’s eyes went huge. “Remember how sick you got on rice pudding when you were carrying Abby?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eeeyew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda turned green at the gills. “Thanks so much for reminding me of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Abashed, Teeny patted her arm. “Oh, honey. I’m so sorry. I wasn’t even thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A long-suppressed memory surfaced from my own pregnancy. I’d gotten so sick from the dressing and spices in a loaded foot-long sub that, to this day, I can’t bear the smell of a sandwich shop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But pregnancy might not be the worst of Linda’s worries, my internal Chicken Little ranted. Nausea and missed periods could signal some truly sinister possibilities at our age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We may be getting all het up for nothing.” As usual, it was Diane who injected some rationality into the situation. She pointed to Linda’s Kate Spade purse holding the pregnancy test. “Let’s take that instant thingie downstairs to the bathroom and find out where we stand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Never mind that Linda might prefer to take the test in the privacy of her own home, alone. “Do it here?” Linda whispered. “Are you nuts?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But this was one cat that couldn’t be put back in the bag. She’d kept mum for at least two months. If she didn’t want us butting in, I reasoned, she wouldn’t have said the pregnancy test was for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And I was just as eager to find out immediately as the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If we do this here, it’ll be all over town by suppertime.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, it won’t.” Taking Linda’s arm and urging her up, Diane rose, a tight smile on her face for the benefit of all the surreptitious glances that turned our way. “Georgia will stand guard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stood and murmured through my own determinedly cheerful expression. “Speak for yourself. I want to be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda pulled free of Diane’s solicitous grasp. “I can still walk by myself, thank you.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In all our years of lunching at the Coach House, we’d never gotten up en masse before, and the regulars noticed. Big time. Conversations all around us lulled with curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think we should all go at once?” Teeny questioned in a whisper. “People are starin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu rose. “Oh, for cryin’ out loud, Teeny. Let’s just go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two of them followed as we headed for the stairs. We made such a spectacle wending through the tables in our red hats and purple outfits, that before long, everybody in the place was watching.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maria came out of the kitchen and frowned in confusion. I detoured close to her and whispered, “Don’t worry. Everything’s under control. We’ll be right back to order in a few minutes.” I made a mental note to add an extra five to the fifty we always gave her to make up for monopolizing her table all day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded, but her expression remained confused.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, there was no private party going on downstairs in the ground-level dining room, so we snagged a chair to block the door and headed into the elegant bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While I positioned myself to block anybody who might try to come in, SuSu took Linda’s shoulders and steered her into the stall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take your time,” SuSu instructed her, “but when you finish, bring the thingie out here. We’re all with you, sweetie.” She gave Linda a hug, then closed the stall door and waited outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, y’all,” Linda groaned out. “What if it’s positive? I am way too old for this nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything’s gonna be fine, sweetie, no matter what,” I told her through the stall door. It had taken me twenty years to train my husband to say that whenever I thought the world was falling apart, but even as I said it to Linda, I wondered how anything could ever be okay if the test was positive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Diapers. No sleep. Spit-up,” she whined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu chimed in with a brisk, “You’ve got plenty of money to hire help. You could just kiss its little head every night at cocktail time, then send it back to the nursery. It’ll adore you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu had been getting witchier and witchier as law school had progressed, a phase we’d all endured with the confidence that she’d eventually come back around, but this was beyond ignoring.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Linda could no more ignore her own child,” I scolded, “than you could have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu sniffed. “Well, she might not even have to.” She leaned toward the door to the stall. “Hurry up and get this thing done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny lifted a finger in inspiration. “Maybe Abby and Osama Damned Boyfriend could raise it.” Now, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there")]), _vm._v(" was an ironic twist. Let the grown child raise the unplanned sibling, instead of the grandparents getting stuck with the unplanned grandbaby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, Gawd!” echoed from the stall. “Just when I thought this couldn’t get worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane rolled her eyes. “Can we please give the woman some peace?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny’s sharp little features condensed in regret. “I was only tryin’ to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Taut silence filled the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a brief rustle of fabric, we heard Linda open the box. Then nothing. And more nothing. And more nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Y’all,” Linda’s plaint echoed from the stalls. “I can’t do anything with you hovering out there listening. You’ve got to go outside. I promise, I’ll come get you as soon as I’m done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay.” Diane herded us toward the door. Outside, we congregated in an anxious huddle at the bottom of the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am serious, y’all,” Diane told us in her teacher-at-the-parent-conference voice. “No matter what happens in there, don’t push her. Just let her know we love her and we’ll be there for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ohmygod,” SuSu murmured, “the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("orchestra pit")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A chortle escaped me and Teeny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A baby, at our age?” Diane mused aloud, but not loud enough to carry up the stairwell. “I’d have to jump off a bridge, that’s all there is to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But why would it be so much worse than a grandchild?” I argued. “Y’all can’t seem to get enough of your grandkids.” And I was so jealous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The P words, honey,” SuSu said. “Pregnancy: we didn’t have to carry them or deliver them. And they’re not permanent; we can send them home with their mommies when we get tired. After a day with Peyton—”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The conversation came to an abrupt halt when a hapless thirty-something wearing Ann Taylor arrived on the landing above us. She halted. “Oh. Is there a line?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I offered a sympathetic grimace. “Sorry. Are you urgent?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head, no.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, good, cause the bathroom’s temporarily out of order,” I lied smooth as eye cream, “but they’re fixing it. Should be done in twenty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Surely it wouldn’t take longer than that for the test to give us the verdict. I had no idea. The last time any of us had been pregnant, you had to go to the doctor and kill a rabbit to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman nodded, just registering our red hats. “Are y’all some kind of club?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The four of us turned to her with a clearly dismissive “yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah.” She literally backed up. “Well, I’ll try again later.” She headed upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bathroom door opened. “Okay.” Linda was holding the plastic stick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We all rushed inside and barricaded the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane peered at the little opening in the stick. “How long does it take?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda frowned. “The box said three minutes. If the line shows up on the square, it’s negative”—which, rumor had it, wasn’t necessarily conclusive—“but if it turns up on the circle, it’s positive.” Now, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" would be conclusive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She checked her watch. “It’s been two minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hope it took more than two minutes to get this way,” SuSu blurted out in a tactless attempt to lighten things up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We all glared at her, then crowded around Linda for a better look at the dreaded section of the plastic wand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda’s mouth trembled. “Oh, y’all, I can’t stand this. Here.” She handed me the wand. “Just tell me what it says. No comments. Just tell me, positive or negative. That’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We nodded as she paced away from us, her arms crossed over her ample chest and her hands gripping her rounded biceps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stared at the indicators. Nothing yet.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu shot a wide-eyed “better her than us” look my way. At least Brooks was devoted to Linda. There was no question that he’d support her no matter what.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda paced, her eyes averted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nothing yet. I pointed to the pregnancy test. “Maybe it’s defective.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, Lord,” Linda moaned out. “Please don’t make me have to get another one and do it again. I drove all the way out to Decatur so I wouldn’t run into anybody I knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’d have gone to Macon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, slowly, a line started to form on the wand. Across the circle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We exchanged looks of dread, then turned our eyes to Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shades of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s Never Too Late")]), _vm._v(", one of my favorite movies about a middle-aged pregnancy, starring Paul Ford and Maureen O’Sullivan came to mind. But this wasn’t Hollywood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sensing our attention, Linda pivoted. One look at us was all it took. “Oh, no.” The words seemed to catch in her throat, cutting off all her air. She went so pale, Diane and SuSu leapt forward to catch her if she fainted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Quick, the chair!” Diane ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I managed to get it under Linda just as she sank down heavily. Pale as a paper towel, she focused her frustration in the safest place. “Damn, y’all. You act like I’m gonna faint. I never fainted in my life. Jewish women only faint if their children marry out of the faith.” Her haggard appearance said otherwise. “What is, is,” she declared as much to herself as to us. “This is not a tragedy. I can deal with this. It’s not like something happened to Brooks or Abby.” She dry-spit three times at the mere mention of such a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never mind that I’ll be sixty when she goes to kindergarten,” she went on, a note of surreal giddiness creeping into her voice, “and seventy-three when college comes around.” Her eyes widened. “Oh, Lord. What if it’s a boy? I don’t know anything about boys. What if he wants to do sports? The only sport Brooks cares about is golf. You can’t play golf with a two-year-old.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu laid a consoling hand on her shoulder. “Aren’t you gonna cry?” she prodded. “Or wring your hands and curse fate? It’s okay. We’ll understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu had a point. Linda was being entirely too calm.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At least cuss!” she went on. “If you don’t do something, this’ll eat you alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda slumped. “I’m too damned tired to act up. And what good would it do, anyway? None.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We presented quite a bizarre picture, huddled around her in our red hats and purple, contemplating what life would be like for Linda with a fresh crop of stretch marks, baby fat, morning sickness, and high-risk complications. Not to mention breast-versus-bottle, midnight feedings, colic, dirty diapers, and finding a decent nanny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If it’s a girl, don’t name her Georgia,” I chimed in, compelled to personalize this child-to-be—if in fact there was one. “She’ll hate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or Tina,” Teeny added. “I never liked my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda shook her head, half-dazed. “We’re Jewish. We only name our children for dead people.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’d forgotten. “Oh, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, maybe Linda’s not going to be naming anybody anything,” SuSu declared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“SuSu!” Diane warned. “Tradition Nine!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nine, schmine,” SuSu shot back without rancor. “We’ve all shot the traditions to smithereens already.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, settle down,” I told her, still not able to accept the fact that this might really be happening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When we’d all had our babies, our friendships had helped us through. But now, and only one of us facing motherhood? “Linda shouldn’t do anything till she’s been to a gynecologist and made sure of exactly what’s going on,” I said. “I still think this could be a hormonal hiccup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda looked to me with doubt and gratitude. “Georgia’s right.” My favorite thing to be. “The only trouble is, my OB/GYN died of an aneurism two weeks ago. Had some poor woman in the stirrups and fell face-first right into her unmentionables. How awful is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I guffawed, eliciting looks of reproach from the others. “Oh, lighten up, y’all. At least Linda still has her sense of humor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny patted Linda’s arm, going misty. “The best times in my life were pregnancy and having little ones,” she said with nostalgia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” SuSu countered, “but you were in your twenties. Linda’s only ten years away from Medicare.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All of us, including Linda, glared at SuSu for yet again bludgeoning us with the obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is not a catastrophe,” Diane said, logical to the last. “We’re with you all the way. Brooks can find you a wonderful OB/GYN to check things out, somebody discreet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda’s brave facade began to crumble. “I’m not sure I want to tell Brooks. Not until I know exactly what I’m up against. And what I want to do about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That caught us up short. Brooks and Linda were practically joined at the hip. I couldn’t conceive of her keeping something this important from him, even for a little while.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We all thought it, but Diane was the one who blew Tradition Five yet again with, “But you have to tell him. He’s the father. You can’t not tell Brooks.” She paused, a wicked gleam in her eye. “He is the father, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, for God’s sakes,” Linda blustered, trying not to smile at the preposterous question. “Of course, he’s the father!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course, he is,” Teeny appeased.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tension broken, Linda blinked in that deadpan way of hers. “Any of y’all know a good obstetrician who specializes in geriatrics?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny raised a finger. “No, but I sure like mine. She’s so nice, and only fifty-eight, so she won’t stroke out on you. And she knows from experience that a hot flash is a hot flash, not a power surge.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me get something to write with.” Linda rummaged up a pen and little notepad from her purse. “What’s her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sandra Castellano. She’s in with four other women at Piedmont. I like them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You should try my doctor,” SuSu offered. “He’s single, gorgeous. Has the greatest dimples, and he flirts with all his patients. Makes me feel like a queen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leave it to SuSu to turn a pelvic exam into a recreational experience. Can we say “Wrong!” Frankly, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("last")]), _vm._v(" place I want to be flirted with is when I’m trussed up in the stirrups.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Only you,” Linda retorted. Then she turned her attention back to Teeny. “Do you know Dr. Castellano’s number?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Teeny rattled it off by heart. “And she gives you her home phone number, too, when you become her patient.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sounds too good to be true.” Linda stuck the pen and tablet back into her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here.” I wrapped the pregnancy test in a paper towel and handed it back to Linda. “Wouldn’t do to leave this lying around where somebody could find it. The gossips would have us all preggers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu sniffed at me in a most superior manner. “Do you honestly think anybody would root around in the trash for something like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” Linda and Diane and I said in unison, eliciting the first genuine laugh since Linda had dropped her bombshell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can see it now.” Diane crooked her pinkie and peered down into the trashcan. “Lucretia Hottentot, special operative from ALTA”—that’s the Atlanta Lawn Tennis Association, for all you nonnatives—“breaks out her rubber gloves and Purel, and dumpster dives for the scoop of the century.” She mimed a banner headline, dead serious. “Respected Buckhead urosurgeon and Fox Theater board member impregnates wife in the orchestra pit after a rousing performance of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aida")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda grinned, the life returning to her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This momentous conception,” Diane went on, “was accomplished without the benefit of Viagra.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda covered her face, embarrassed, even as she nodded in confirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane’s tone dropped to FM levels. “Breaking with Jewish tradition, the child will be named for an inanimate object, not a dead person. If a boy, Bassoon. If a girl, Timpani and Glockenspiel are front-runners.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I flashed on the dead gynecologist with his face in his patient’s privates, and let out a peal of semihysterical laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Easy, girl.” Diane motioned us toward the door. “Come on. This calls for white wine.” She pointed to Linda. “For everybody but you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda bristled. “I drank a glass of wine with supper the whole time I was carrying Abby, and it didn’t hurt a thing. So count me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’d all indulged (in moderation) during our pregnancies, but at least we’d had the good sense to stop smoking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well,” Diane capitulated. “Maybe just one glass. Just this once.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As we started up the stairs, we met the woman from the landing, who greeted us with a cheery. “Oh, good. Everything back in order?”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Honey,” Linda said, “everything’s about as out of order as it can get, but the toilets work just fine.” With that, her tickle box tumped over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her giggles were contagious. We all dissolved as the confused woman edged by at a safe distance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on,” I told the others, wiping happy-sad tears of release from my cheeks. “Double frozen fruit salads are on me.” After all, Linda was eating for two.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe.")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371a2d8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312316914_ch03.vue
// module id = 72
// module chunks = 0